import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CookieJs from "js-cookie";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useQuery } from "react-query";
import link from "../../services/link";
import getImageLink from "../../utils/getImageLink";
import queryDefault from "../../utils/queryDefault";
import PageName from "../components/PageName";

export default function CompanyInfo() {
  const [optionCompanyInfo] = useState<any>({
    keyword: "companyInfo",
  });
  const listCompanyinfo: any = useQuery(
    ["companyInfo", optionCompanyInfo],
    ({ queryKey }) => {
      return link.getLinks({
        ...queryKey[1],
      });
    },
    {
      ...queryDefault,
    }
  );
  const [optionCompanyinfoMobile] = useState<any>({
    keyword: "companyInfoMobile",
  });
  const listCompanyinfoMobile: any = useQuery(
    ["companyInfoMobile", optionCompanyinfoMobile],
    ({ queryKey }) => {
      return link.getLinks({
        ...queryKey[1],
      });
    },
    {
      ...queryDefault,
    }
  );

  const [lang, setLang] = useState("en");
  useEffect(() => {
    const cookieLang = CookieJs.get("lang");
    if (cookieLang !== undefined) {
      setLang(cookieLang);
    }
  }, []);
  const changeLanguage = (event: SelectChangeEvent) => {
    if (event.target.value !== lang) {
      CookieJs.set("lang", event.target.value);
      setLang(event.target.value);
      window.location.reload();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#FDF3DF",
        height: "100vh",
        paddingRight: "5vw"
      }}
    >
      <Helmet>
        <title>{lang === "en" ? "Company Info" : "Info Perseroan"}</title>
      </Helmet>

      <PageName page={lang === "en" ? "COMPANY INFO" : "INFO PERSEROAN"} width={lang === "en" ? "360" : "350"} />

      <FormControl sx={{ position: "absolute", top: "20px", right: "70px", zIndex: 99, backgroundColor: "rgb(253, 243, 223)", borderRadius: "5px" }}>
        <InputLabel id="lang-label">{lang === "en" ? "Language" : "Bahasa"}</InputLabel>
        <Select labelId="lang-label" id="lang" value={lang} label={lang === "en" ? "Language" : "Bahasa"} onChange={changeLanguage}>
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="id">Indonesia</MenuItem>
        </Select>
      </FormControl>

      <Box
        height="100%"
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          [theme.breakpoints.up("lg")]: { width: "calc(100vw - 300px)" },
        })}
      >
        {!listCompanyinfo.isLoading && !listCompanyinfoMobile.isLoading ? (
          <a
            href={listCompanyinfo.data?.data[0]?.url}
            target="_blank"
            rel="noreferrer"
            style={{ width: "100%" }}
          >
            <picture>
              <source
                media="(min-width:900px)"
                srcSet={getImageLink(listCompanyinfo.data?.data[0]?.link, 1440)}
              />
              <img
                src={getImageLink(listCompanyinfoMobile.data?.data[0]?.link, 1440)}
                style={{ width: "90%", height: 'auto', maxHeight: '100vh' }}
                alt="Location"
              />
            </picture>
          </a>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
}
